import {create} from 'zustand';

interface CheckoutActions {
  CHECKOUT_ACTION_BUY_NOW: symbol;
  CHECKOUT_ACTION_ADD_TO_CART: symbol;
  CHECKOUT_ACTION_CREATE_ORDER: symbol;
  CHECKOUT_ACTION_CREATE_QUOTE: symbol;
  CHECKOUT_ACTION_CREATE_INFO: symbol;
  CHECKOUT_ACTION_EMAIL_PREVIEW: symbol;
  CHECKOUT_ACTION_DEBUG: symbol;
  CHECKOUT_ACTION_COMPLETE: symbol;
  CHECKOUT_ACTION_ERROR: symbol;
};

export const checkoutActions: CheckoutActions = {
  CHECKOUT_ACTION_BUY_NOW: Symbol('CHECKOUT_ACTION_BUY_NOW'),
  CHECKOUT_ACTION_ADD_TO_CART: Symbol('CHECKOUT_ACTION_ADD_TO_CART'),
  CHECKOUT_ACTION_CREATE_ORDER: Symbol('CHECKOUT_ACTION_CREATE_ORDER'),
  CHECKOUT_ACTION_CREATE_QUOTE: Symbol('CHECKOUT_ACTION_CREATE_QUOTE'),
  CHECKOUT_ACTION_CREATE_INFO: Symbol('CHECKOUT_ACTION_CREATE_INFO'),
  CHECKOUT_ACTION_EMAIL_PREVIEW: Symbol('CHECKOUT_ACTION_EMAIL_PREVIEW'),
  CHECKOUT_ACTION_DEBUG: Symbol('CHECKOUT_ACTION_DEBUG'),
  CHECKOUT_ACTION_COMPLETE: Symbol('CHECKOUT_ACTION_COMPLETE'),
  CHECKOUT_ACTION_ERROR: Symbol('CHECKOUT_ACTION_ERROR'),
};

interface CheckoutStore extends CheckoutActions {
  processing: boolean;
  success: boolean;
  error: object | null;
  payload: object | null;
  action: symbol | null;
  dispatch: (action: symbol, payload?: object) => void;
};

const useCheckoutStore = create<CheckoutStore>((set, get) => ({
  processing: false,
  success: false,
  error: null,
  payload: {},
  action: null,
  ...checkoutActions,
  setProcessing: (processing: boolean) => set({ processing }),
  dispatch: (action, payload) => {
    switch(action) {
      case checkoutActions.CHECKOUT_ACTION_CREATE_ORDER:
      case checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE:
      case checkoutActions.CHECKOUT_ACTION_ADD_TO_CART:
      case checkoutActions.CHECKOUT_ACTION_BUY_NOW:
      case checkoutActions.CHECKOUT_ACTION_EMAIL_PREVIEW:
        set({ action, payload });
        break;
      case checkoutActions.CHECKOUT_ACTION_COMPLETE:
        set({ processing: false, action: null, payload });
        break;
      case checkoutActions.CHECKOUT_ACTION_ERROR:
        set({ processing: false, action: null, payload });
        break;
      default: 
        // unhandled action
        console.log('checkoutStore: dispatch unknown action');
        break;
    }
  }
}));

export default useCheckoutStore;